// extracted by mini-css-extract-plugin
export var errorIcon = "_j8-1";
export var nameLogo = "_j8-0";